/** Forma cererii de marfă, așa cum o întoarce API-ul. Folosită de filă și de ecranul transversal. */
export interface LinieCerere {
  id: number
  productId: number
  sku: string
  denumire: string
  cantitateCeruta: number
  cantitateAprobata: number | null
  transferat: number
  rest: number
  /** S-a transferat mai mult decât s-a aprobat — se poate întâmpla la o cursă între doi oameni. */
  peste: boolean
}

export interface Cerere {
  id: number
  campanieId: number
  /** `tip` decide textul implicit al bonului de consum — vezi `motivBonImplicit`. */
  campanie: {
    id: number
    cod: string
    titlu: string
    tip?: string
    dataStart?: string
    dataFinal?: string | null
  }
  /** Pentru care acțiune de teren s-a cerut. `null` = cerere pe activitate în general. */
  actiuneId: number | null
  actiune: { id: number; denumire: string; tip: string } | null
  status: string
  motiv: string | null
  motivRespingere: string | null
  ceruteDe: { id: number; name: string | null; email: string; role?: string } | null
  ceruteDeId: number
  /* Cererea care pleacă direct: cui, unde, cât cântărește, și ce documente au ieșit. */
  tip?: 'activitate' | 'colaborator' | 'partener'
  influencer?: {
    id: number
    handle: string
    platform: string
    numeDestinatar: string | null
    telefon: string | null
    judet: string | null
    localitate: string | null
    strada: string | null
    numarStrada: string | null
    codPostal: string | null
  } | null
  /** Beneficiarul persoană juridică, la cererile de tip `partener`. */
  client?: { id: number; name: string; cif: string | null } | null
  /** Unde pleacă coletul. Se completează pe cerere, nu pe fișa partenerului. */
  livrare?: {
    nume: string | null
    telefon: string | null
    judet: string | null
    localitate: string | null
    strada: string | null
    numar: string | null
    codPostal: string | null
    contact?: string | null
    email?: string | null
    bloc?: string | null
    scara?: string | null
    etaj?: string | null
    apartament?: string | null
  } | null
  /** „Trimite prin curier": AWB după aprobare, cu datele din `livrare`. */
  prinCurier?: boolean
  /** Bonul de consum ieșit la expediere. */
  bonNrDoc?: string | null
  bonEaDocNo?: string | null
  /** Procesul-verbal de predare-primire, odată generat. */
  pvNr?: string | null
  pvLa?: string | null
  greutateGrame?: number | null
  awbNumber?: string | null
  awbLa?: string | null
  awbCost?: number | null
  awbEroare?: string | null
  /** Cine a apăsat „Expediază”. */
  awbDe?: { id: number; name: string } | null
  /** AWB cerut la FAN, cu rezultatul încă nevenit. Vezi `rezervareAwb` pe server. */
  awbInCursLa?: string | null
  /** Cerut, dar nu se știe dacă a ieșit: FAN n-a răspuns. Nu se emite altul până nu verifică cineva. */
  awbNesigur?: boolean
  /**
   * Unde a ajuns coletul, din urmărirea de la Bani → Rambursuri curieri.
   *
   * `null` până când borderoul zilnic al lui FAN aduce AWB-ul — un colet expediat acum zece
   * minute încă n-are rând acolo. Lipsa nu e o gaură, e „încă nepreluat de curier".
   */
  stareAwb?: {
    ultimaMiscare: string | null
    ultimaMiscareLa: string | null
    ultimaMiscareUnde: string | null
    livratLa: string | null
    returAwb: string | null
    inchisLa: string | null
    seIntoarce: boolean
    blocatDin: string | null
    /** Zile lucratoare la curier, peste pragul unic de intarziere (4); altfel null. */
    intarziere: number | null
  } | null
  trimisaLa: string | null
  aprobatDe: { id: number; name: string | null; email: string } | null
  aprobatLa: string | null
  createdAt: string
  linii: LinieCerere[]
  restTotal: number
  /**
   * Valoarea la preț de cost (aprobat, sau cerut până la aprobare). Doar în lista „Cereri de
   * marfă". `null` = niciun produs n-are preț; `valoareIncompleta` = unele n-au.
   */
  valoare?: number | null
  valoareIncompleta?: boolean
}

export const ETICHETA_STARE: Record<string, string> = {
  ciorna: 'Ciornă',
  trimisa: 'Trimisă',
  returnata: 'Trimisă înapoi',
  aprobata: 'Aprobată',
  respinsa: 'Respinsă',
  transferata: 'Transferată',
  inchisa: 'Închisă',
}

export const CULOARE_STARE_CERERE: Record<string, string> = {
  ciorna: 'bg-b4l-bg text-b4l-text-muted',
  trimisa: 'bg-b4l-amber-light text-b4l-amber-dark',
  returnata: 'bg-b4l-amber-light text-b4l-amber-dark ring-1 ring-inset ring-b4l-amber',
  aprobata: 'bg-b4l-blue-light text-b4l-blue-dark',
  respinsa: 'bg-b4l-red-light text-b4l-red-dark',
  transferata: 'bg-b4l-green-light text-b4l-green-dark',
  inchisa: 'bg-b4l-purple-light text-b4l-purple-dark',
}
